module.exports = __webpack_public_path__ + "ce090251d0d047d6bdfd8936e23149b3.MP3";